export  const validatePhone = (phone) => {
    // Accepts formats: (123) 456-7890, 123-456-7890, 123.456.7890, 1234567890
    const phoneRegex =
      /^[+]?[1-9][\d]{0,15}$|^(\([0-9]{3}\)\s?|[0-9]{3}[-\s.]?)[0-9]{3}[-\s.]?[0-9]{4}$/;
    if (!phone) {
      return 'Phone number is required';
    }
    if (!phoneRegex.test(phone.replace(/[\s\-.()]/g, ''))) {
      return 'Please enter a valid phone number';
    }
    return '';
  };

  // Validation functions
  export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return 'Email is required';
    }
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

